export default "__VITE_PUBLIC_ASSET__8991cb3a__"